<google-map
  (mapClick)="onMapClick($event)"
  [height]="'100%'"
  [options]="options ? options : baseMapOptions"
  [width]="'100%'"
>
  <map-advanced-marker
    #markerElem="mapAdvancedMarker"
    (mapDragend)="onMarkerDragEnd($event)"
    *ngIf="markerCoordinates"
    [gmpDraggable]="true"
    [position]="{
      lat: markerCoordinates.latitude,
      lng: markerCoordinates.longitude
    }"
  ></map-advanced-marker>
</google-map>
